<style lang="less">
@import "../../../../styles/common.less";
</style>
<template>
  <div class="evidenceInfo" style="width:890px;">
    <div class="evidenceInfo-top" style="height:787px">
      <div class="evidenceInfo-top-title" style="margin-bottom:0px">存证详情</div>
      <ul class="cert-info-ul">
         <li>
          <span style="width:185px;margin-left:30px">存证名称：</span>
          <span class="span-right">{{showList.orderTitle}}</span>
        </li>
        <li>
          <span style="width:185px;margin-left:30px">区块链联盟公示：</span>
          <span class="span-right">{{showList.publicHash?showList.publicHash:'-'}}</span>
        </li>
        <li>
          <span style="width:185px;margin-left:30px">存证数据包校验值：</span>
          <span class="span-right">{{showList.zipHash?showList.zipHash:'-'}}</span>
        </li>
        <li>
          <span style="width:185px;margin-left:30px">校验算法：</span>
          <span class="span-right">SHA256</span>
        </li>
        <li>
          <span style="width:185px;margin-left:30px">存证数量：</span>
          <span class="span-right">{{showList.attachmentsNum?showList.attachmentsNum:0}}个文件</span>
        </li>
        <li>
          <span style="width:185px;margin-left:30px">提交存证时间：</span>
          <span class="span-right">{{showList.createDate}}</span>
        </li>
        <li>
          <span style="width:185px;margin-left:30px">存证证书下发时间：</span>
          <span class="span-right">{{showList.evidenceArchiveCertTime?showList.evidenceArchiveCertTime:'-'}}</span>
        </li>
      </ul>
      <h2>存证附件展示：</h2>
      <div class="img-list common-scroll-style">
        <ul class="img-list-ul">
          <li v-for="(item,index) in showArray" :key="index">
            <img :src="item.attachmentUrl" class="cert-lists-img" alt='版权登记'/>
            <p class="notwrap">{{item.attachmentName}}</p>
          </li>

        </ul>
      </div>
    </div>
    <div class="evidenceInfo-top" v-if="showList.orderAuditStatus=='cert_sign_issue'" style="min-height:357px">
      <div class="evidenceInfo-top-title">存证证书</div>
      <div class="evidence-bottom">
        <div style="width:166px;margin-right:20px"><img src="@/assets/cert-img.png" alt='版权登记'/></div>
        <div class="evidence-bottom-right">
          <p class="p-one">{{showList.orderTitle}}</p>
          <ul class="evidence-bottom-ul">
            <li>
              <span style="width:70px">证书状态：</span>
              <span>已认证</span>
            </li>
             <li>
              <span style="width:70px">证书编号：</span>
              <span>{{showList.evidenceArchiveCertNumber}}</span>
            </li>
             <li>
              <span style="width:70px">核验单位：</span>
              <span>中国科学院国家授时中心、北京天威诚信电子商务服务有限公司、版权区块链联盟</span>
            </li>
             <li>
              <span style="width:70px">认证日期：</span>
              <span>{{showList.evidenceArchiveCertTime?showList.evidenceArchiveCertNumber.split(' ')[0]:''}}</span>
            </li>
          </ul>
          <div>
            <button class="btn-76" @click="goGy()">证书核验</button>
            <button class="btn-76" @click="downBook(showList.orderSeqNo)" style="margin:0px 15px">下载证书</button>
            <button class="btn-76" @click="downDataBook(showList.orderSeqNo)" style="width:126px">下载存证数据包</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
      title: '我的存证详情|前海版权综合服务平台',
      meta: [{                 // set meta
          name: 'keyWords',
          content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
      },{
          name: 'Description',
          content: '我的存证详情,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
      }]
  },
  name: "myCertDetail",
  data(){
    return{
      total:10,
      showList:{},
      showArray:[],
    }
  },
  methods:{
    showMessage(){
      let id = this.$route.query.id;
      let _this = this;
      this.getRequest("/orderCommon/get/" + id).then(res => {
        console.log('++++++++++++++++++++++++++',res)
        if(res.code == 200){
          _this.showList = res.result;
          _this.showArray = res.result.attachments;
        }
      })
    },
    downBook(id){
      this.getRequest("/orderCommon/downloadCert/" + id).then(res => {})
    },
    downDataBook(id){
      console.log( this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id);
      window.open( this.API_ROOT_UPLOAD + "bqjvip/orderCommon/downloadZip/" + id, '_blank');
    },
  },
  mounted(){
    this.showMessage()
  }
};
</script>
<style scoped lang="less">
.cert-info-ul{
  overflow: hidden;
  li{
    font-size:14px;
    color:rgba(102,102,102,1);
    line-height:20px;
    padding:17px 0px;
    display: flex;
    box-sizing: border-box;
    border-bottom: 1px solid #F1F1F1;
    .span-right{
      flex:1;
      word-break: break-all;
    }
  }
  li:nth-child(odd){
    background:rgba(252,252,252,1);
  }
}
h2{
  font-size:14px;
  color:rgba(102,102,102,1);
  font-weight: 400;
  line-height:20px;
  margin:20px 30px;
}
.img-list{
  height: 210px;
  margin-left: 30px;
  overflow: auto;
  .img-list-ul{
    overflow: hidden;
    li{
      float: left;
      height: 190px;
      margin-right: 20px;
      margin-bottom: 20px;
      list-style: none;
      position: relative;
      .cert-lists-img{
        width:274px;
        height: 154px;
        margin-bottom:10px;
      }
      .cert-lists-icon{
        position: absolute;
        width:24px;
        height:24px;
        top:10px;
        left:10px;
      }
      .dci-tip{
        width:274px;
        height:34px;
        line-height: 34px;
        background:rgba(255,255,255,1);
        opacity:0.8;
        position: absolute;
        bottom:36px;
        left:0;
        text-indent: 7px;
        font-size: 12px;
        color:#3A3A3A;
      }
      p{
        font-size:14px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:20px;
        width:274px;
      }
    }
  }
}
</style>
